export default [
    [
        "International",
        "red"
    ],
    [
        "International City",
        "red"
    ],
    [
        "US Subdivision",
        "blue"
    ],
    [
        "US City",
        "blue"
    ],
    [
        "Census",
        "cyan"
    ],
    [
        "Political",
        "purple"
    ],
    [
        "Oddball",
        "darkGrey"
    ],
    [
        "Kavi",
        "brown"
    ],
    [
        "School",
        "yellow"
    ],
    [
        "Small",
        "pink"
    ],
    [
        "Native",
        "green"
    ]
] as const